var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosicionMapa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 112 112",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 52.532755,99.6 C 51.107274,97.708 48.671472,94.504 47.119862,92.48 21.898973,59.580579 17.140889,48.169814 22.100932,32.48 32.914531,-1.7260294 81.458499,-0.4929607 90.459987,34.216394 94.326141,49.124125 89.960211,59.296397 66.217946,90.698442 54.843933,105.74196 56.398448,104.73082 52.532755,99.6 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosicionMapa);
export default __webpack_public_path__ + "static/media/posicionMapa.2a810b608a5b1657662663e65667aadc.svg";
export { ForwardRef as ReactComponent };